import { Link } from 'react-router-dom';
import { get } from '../api';

export default function PlayPage() {
  const handleTest = () => get('auth/test').then(console.log);

  return (
    <>
      <Link className="button is-primary" to="/setup">
        Create Game
      </Link>
      <button className="button" onClick={handleTest}>
        test
      </button>
    </>
  );
}
